import * as React from "react";
import { useMediaQuery } from "../../hooks/use-media-query";
import { Button } from "../../components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "../../components/ui/command";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "../../components/ui/drawer";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";
import { cities } from "./locationsData";

type city = {
  value: string;
  label: string;
};

export function LebaneseCities({
  getCity,
}: {
  getCity: (city: city | null) => void;
}) {
  const [open, setOpen] = React.useState(false);
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const [selectedCity, setSelectedCity] =
    React.useState<city | null>({
      label: "Chtaura",
      value: "Chtaura",
    });

  if (isDesktop) {
    return (
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className="w-full rounded-none justify-start"
          >
            {selectedCity ? (
              <>{selectedCity.value}</>
            ) : (
              <>Select City</>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className="w-full rounded-none p-0"
          align="start"
        >
          <StatusList
            setOpen={setOpen}
            setSelectedCity={(city) => {
              setSelectedCity(city);
              getCity(city);
            }}
          />
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button
          variant="outline"
          className="w-full rounded-none justify-start"
        >
          {selectedCity ? (
            <>{selectedCity.label}</>
          ) : (
            <>Select City</>
          )}
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <div className="mt-4 border-t">
          <StatusList
            setOpen={setOpen}
            setSelectedCity={setSelectedCity}
          />
        </div>
      </DrawerContent>
    </Drawer>
  );
}

function StatusList({
  setOpen,
  setSelectedCity,
}: {
  setOpen: (open: boolean) => void;
  setSelectedCity: (city: city | null) => void;
}) {
  return (
    <Command>
      <CommandInput placeholder="Search City..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup>
          {cities.map((city) => (
            <CommandItem
              key={city.value}
              defaultValue={"Chtaura"}
              value={city.value}
              onSelect={() => {
                setSelectedCity(city);
                setOpen(false);
              }}
            >
              {city.label}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
